/**
 * API base URL. CRA bakes REACT_APP_* at compile time; we normalize port 8000 → 8001
 * (common typo / stale cache) so the app matches `uvicorn ... --port 8001`.
 */
function resolveBackendUrl() {
  const fallback = "http://127.0.0.1:8001";
  const raw = (process.env.REACT_APP_BACKEND_URL || "").trim();
  let url = raw || fallback;
  url = url
    .replace(/\b127\.0\.0\.1:8000\b/, "127.0.0.1:8001")
    .replace(/\blocalhost:8000\b/, "127.0.0.1:8001");
  return url.replace(/\/$/, "");
}

export const BACKEND_URL = resolveBackendUrl();
